import styled, {css} from "styled-components"


const TradeWrapper = styled.div`
    width: 100%;
    height: calc(100% - 60px);
    margin-top: 60px;
    border-top: 1px solid ${props => props.theme.color}15;
    background-color: ${props => props.theme.tradeBg};
    position: relative;
    z-index: 0;
    direction: ltr;
`

const TradeHead = styled.div`
    position: absolute;
    width: 100px;
    height: 60px;
    color: ${props => props.theme.secondary};
    font-size: 0.9rem;
    left: 0; 
    border-right: 1px solid ${props => props.theme.color}15;
    border-top: 1px solid ${props => props.theme.mainOrange};
    top: -60px;
    z-index: 1;
    background-color: ${props => props.theme.tradeBg};
`

const TradeInputBody = styled.div`
    background-color: ${props => props.theme.tInputBg};
    width: 100%;
    height: 2.4rem;
    border-radius: 4px;
    margin: 0 20px;
    position: relative;

    ${props => props.active && css`
        border: 1px solid ${props => props.theme.mainOrange};
    `}

    &:hover{
        ${props => (props.hover && !props.error) && css`
            border: 1px solid ${props => props.theme.mainOrange};
        `}
    };
    
    ${props => props.error && css`
      border: 1px solid ${props => props.theme.exitRed};
    `};

    @media screen and (max-width: 1400px) {
        height: 2.2rem;
    };

  @media screen and (max-width: 480px) {
    margin: 0 4px;
  }
    
`

const TInput = styled.input`
    width: 100%;
    height: 100%;
    background-color: transparent;
    text-align: end;
    border: none;
    padding: 0 4px;
    font-family: monospace;
    color: ${props => props.theme.secondary};
    direction: ltr;
    outline: none;
  
  @media screen and (max-width: 768px){
    font-size: 0.7rem;
  }
`

const TradeBtn = styled.div`
    width: 100%;
    border-radius: 4px;
    background-color: ${({ type, theme, verified }) =>
        verified ?
            type === "buy" ? theme.mainGreen : "#f6465d"
            : theme.input
    };
    height: 2.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    //letter-spacing: 1.3px;
    cursor: pointer;
    transition: all 0.3s;
    color: ${props => props.verified ? props.theme.primary : props.theme.color};
    font-size: 0.75rem;
    ${props => props.warning && css`
      background-color: ${props => props.theme.mainOrange};
      color: #000000;
    `};
  
    &:hover{
        background-color: ${({ type, theme, verified }) =>
        verified ?
            type === "buy" ? "#55E8A5" : "#F75D71"
            : theme.input
    }}
`

const TypeWrapper = styled.div`
  width: 90%;
  height: 34px;
  background-color: ${props => props.theme.tInputBg};
  border-radius: 8px;
  box-shadow: 0 0 2px ${props => props.theme.tradeBg};
  display: flex;
`

const TypeTab = styled.div`
  width: ${props => props.active ? "55%" : "45%"};
  height: 100%;
  background-color: ${({theme, active, type}) => active ? (type === "buy" ? theme.mainGreen : theme.mainRed) : "transparent"};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({active, theme}) => active ? theme.primary : theme.color};
  font-size: 0.7rem;
  cursor: pointer;
  font-weight: 600;
  //letter-spacing: 1.5px;
  transition: all 0.3s;
  ${props => props.type === "buy" && css`
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  `};
  ${props => props.type === "sell" && css`
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  `};
`


const DigiMinexGridLayout = styled.div`
  display: grid;
  grid-row-gap: 2px;
  grid-column-gap: 2px;
  grid-template-areas:
    "a a a a a a a a a a b b"
    "c c c c c c c c c c d d"
    "e e e e e e f f f f g g"
    "x x x x x x x x x x x x"
  ;
`

const GridItem = styled.div`
  grid-area: ${props => props.area};
`

export {
    TradeWrapper,
    TradeHead,
    TradeInputBody,
    TInput,
    TradeBtn,
    TypeWrapper,
    TypeTab,
    DigiMinexGridLayout,
    GridItem
}
